import { LineController, defaults } from "chart.js";
class TextChart extends LineController {
    draw() {
        var _a, _b, _c, _d;
        let parent = this.chart.canvas.parentElement;
        let canvas = this.chart.chartArea;
        let subtitle = (_b = (_a = this.chart.options.plugins) === null || _a === void 0 ? void 0 : _a.subtitle) === null || _b === void 0 ? void 0 : _b.text;
        let align = ((_d = (_c = this.chart.options.plugins) === null || _c === void 0 ? void 0 : _c.subtitle) === null || _d === void 0 ? void 0 : _d.align) || "start";
        let cssAlign = align === "start"
            ? "onvo-text-left"
            : align === "end"
                ? "onvo-text-right"
                : "onvo-text-center";
        if (parent && subtitle) {
            let elems = parent.getElementsByClassName("onvo-separator");
            for (let i = 0; i < elems.length; i++) {
                elems[i].remove();
            }
            let div = document.createElement("div");
            div.className =
                "onvo-separator onvo-overflow-y-hidden onvo-bottom-0 onvo-prose onvo-prose-slate onvo-prose-sm dark:onvo-prose-invert " +
                    cssAlign;
            div.style.position = "absolute";
            div.style.left = canvas.left - 3 + "px";
            div.style.top = canvas.top + "px";
            div.style.height = canvas.height + "px";
            div.style.width = canvas.width + "px";
            div.style.maxWidth = canvas.width + "px";
            div.style.color = defaults.color;
            div.style.font = "14px " + defaults.font.family;
            div.innerHTML =
                typeof subtitle === "string" ? subtitle : subtitle.join("<br />");
            parent.appendChild(div);
        }
    }
}
TextChart.id = "text";
TextChart.overrides = {
    plugins: {
        legend: {
            display: false,
        },
        subtitle: {
            text: [],
            display: false,
        },
    },
    scales: {
        x: {
            display: false,
        },
        y: {
            display: false,
        },
    },
};
export default TextChart;
//# sourceMappingURL=TextChart.js.map